import {
  WizardDropdown,
  WizardDropdownOption,
} from 'common/components/WizardControls/WizardDropdown';
import { Variety } from 'common/models';
import { FC } from 'react';
import { CenteredText } from '../../RatesView/Tabs/styles';
import { dropdownHeightStyling } from '../../styles';

/**
 * A component that displays a dropdown to select a variety when in edit mode.
 *
 * @remark It inherently uses `react-hook-form` for form state management.
 */
export const VarietySelector: FC<{
  control: unknown;
  value: { formValueKey: string; displayValue: string };
  options: WizardDropdownOption<Variety>[];
  isLoading: boolean;
  isEditing: boolean;
  isSubmitting: boolean;
}> = ({ control, value, options, isLoading, isEditing, isSubmitting }) =>
  isEditing ? (
    <CenteredText>
      <WizardDropdown<Variety>
        key={value.formValueKey}
        formControl={control}
        name={value.formValueKey}
        options={options}
        maxWidth='110px'
        styles={dropdownHeightStyling}
        isLoading={isLoading}
        isDisabled={!isEditing || isSubmitting}
        // Keep form state value because of a bug when opening the form twice.
        shouldUnregister={false}
      />
    </CenteredText>
  ) : (
    <CenteredText>{value.displayValue}</CenteredText>
  );
